import React from "react"
import "semantic-ui-css/semantic.min.css"
import { Message } from "semantic-ui-react"

import Comment from "./Comment.js"
import InvoicesPopup from "./InvoicesPopup.js"
import formatAmount from '../../../contexts/Database/Database.functions/formatAmount'

const TransactionDetailsSidebar = ({
  isReconciledSuccessMessageVisible,
  onSetBankTransferReconciledPress,
  onReconcileSuccessMessageClose,
  onSidebarClose,
  onSideBarPrevPagePress,
  onSideBarNextPagePress,
  onSubmitCommentPress,
  selectedBankTransfer,
  selectedBankTransfer: {
    bankTransferAmountFormattedString = '',
    date = '',
    invoice0DeltaAmount = 99999,
    invoice0DeltaAmountString = '',
    invoice0DeltaPaymentDueDateInDays = NaN,
    invoice0PaymentDueDateStr = '',
    invoice0EnterpriseCode = '',
    label = '',
  } = {},
  commentErrorMessage = '',
  sideBarReconcileButtonColor = 'grey',
  sideBarReconcileButtonText = 'Reconcile',
  onSideBarNextPress = () => { },
  onSideBarPrevPress = () => { },
  ...logic
} = {}) => {
  return (
    <div className="sidebar-body">
      <div className="sidebar">
        <div className="main-sidebar">
          {/* Bouton de fermeture */}
          <button
            className="close-button ui button"
            onClick={onSidebarClose}
            type="button"
            aria-label="Fermer"
          >
            <i
              className="close icon"
              style={{
                margin: 0,
              }}
            />
          </button>

          <div className="top-buttons">
            <button type="button" onClick={onSideBarPrevPagePress}>
              <i className="arrow left icon" />
              Prev p.
            </button>
            <button type="button" onClick={onSideBarPrevPress}>
              <i className="arrow up icon" />
              Prev
            </button>
            <button type="button" onClick={onSideBarNextPress}>
              <i className="arrow down icon" />
              Next
            </button>
            <button type="button" onClick={onSideBarNextPagePress}>
              <i className="arrow right icon" />
              Next p.
            </button>
          </div>

          <div className="top-sidebar">
            <h1 className="cost">
              {bankTransferAmountFormattedString}
            </h1>
            <p className="client-label">
              {label}
            </p>
            <p>
              {`Date : ${date}`}
            </p>
            <p>
              {`Payment Due Date : ${invoice0PaymentDueDateStr}`}
            </p>
            <p>
              {`Delta Amount : ${formatAmount(Math.abs(invoice0DeltaAmount))}${
                invoice0DeltaAmount < 0
                  ? ' ➕ MORE'
                  : invoice0DeltaAmount > 0
                    ? ' ➖ LESS'
                    : ''
              }${Math.abs(invoice0DeltaAmount) <= 1 ? ' ✅' : ''}`}
            </p>
            <p>
              {`Delta Payment Due Date In Days : ${`${invoice0DeltaPaymentDueDateInDays}` === 'NaN' ? '' : `${invoice0DeltaPaymentDueDateInDays}`} days`}
            </p>
          </div>
          <hr className="separation" />
          <div className="middle-sidebar">
            <p className="client-name">
              <span>Enterprise code</span>
              <span>{invoice0EnterpriseCode}</span>
            </p>
            <span className="edit-button">
              <i className="edit icon" />
            </span>
          </div>
        </div>
        <div className="bottom-sidebar">
          {/* InvoicesPopup Invoice
          */}
          <InvoicesPopup
            {...logic}
            selectedBankTransfer={selectedBankTransfer}
            // invoicesDateFilter={invoicesDateFilter}
            // invoicesAmountFilter={invoicesAmountFilter}
            // onInvoicesAmountFilterChange={onInvoicesAmountFilterChange}
            // onInvoicesDateFilterChange={onInvoicesDateFilterChange}
            // selectedBankTransfer={selectedBankTransfer}
          />

          <br />
          <br />

          {/* Commentaire */}
          <Comment
            onSubmitCommentPress={onSubmitCommentPress}
            commentErrorMessage={commentErrorMessage}
            selectedBankTransfer={selectedBankTransfer}
          />
        </div>
        {isReconciledSuccessMessageVisible && (
          <Message
            success
            className="reconcile-message"
            onDismiss={onReconcileSuccessMessageClose}
            header="Reconciliation Successful"
            content="The transfer has been reconciled successfully."
          />
        )}
        <button
          type="button"
          className={`reconcile-button ui labeled icon ${sideBarReconcileButtonColor} button`}
          onClick={async () => {
            await onSetBankTransferReconciledPress(selectedBankTransfer)
          }}
        >
          <i className="check icon" />
          {sideBarReconcileButtonText}
        </button>
      </div>
    </div>
  )
}

export default TransactionDetailsSidebar
